/*
calendar
*/

import VanillaCalendar from 'vanilla-calendar-pro';

//theme-ajax.phpから受け取った変数
var ajaxurl = nichiei_ajax_call.ajax_url,
  ajaxnonce = nichiei_ajax_call.ajax_nonce,
  ajaxaction = nichiei_ajax_call.action,
  xhr;

const body = document.querySelector('body');
const wrapper = document.querySelector('.calendar-wrapper');
let calendar;


if (body.classList.contains('post-type-archive-report')) {
  //現場レポートのアーカイブの場合

  //Ajaxのresponseを格納する変数
  let resp;

  function ajax_call(y, m) {

    return new Promise((resolve, reject) => {

      //y,mには現在表示しているカレンダーの初月の値が入っている
      var data = 'action=' + ajaxaction + '&y=' + y + '&m=' + m + '&security=' + ajaxnonce;
      data = encodeURI(data);

      xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxurl, true);
      xhr.timeout = 3000;
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var response = xhr.responseText;
            resolve(response);
          }
        } else {
          if (xhr.status === 0) {
            reject('ajax failed');
          }
        }
      }
      xhr.ontimeout = function () {
        reject('ajax timeout');
      }
      xhr.onerror = function (e) {
        reject('ajax error : ' + e);
      }
      xhr.send(data);
    })
  }

  function loadNew(y, m) {

    let result = ajax_call(y, m);


    result.then(function (response) {
      //responseの中身：配列[投稿の日付、投稿タイトル、パーマリンク]

      resp = JSON.parse(response);

      // console.log('AJAX RESPOINSE');
      // console.log(resp);

      let newPopups = new Object();

      resp.forEach((r) => {
        let data = { modifier: "has-post", html: 'html', href: r[2]};
        data.html = `<a href="` + r[2] + `">` + r[1] + `</a>`,
          newPopups[r[0]] = data;
      });

      //カレンダーにpopup追加（vanilla-calendar function)
      calendar.popups = newPopups;
      calendar.update();
      if (wrapper) {
        wrapper.classList.add('ajax-end');
      }

    })
      .catch(function (error) {
        console.log('ajax error : ' + error);
      });
  }


  //カレンダー初期化

  //現在
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); //0-11

  //今月末 = date.max
  const currentMonth_lastDate = new Date(currentYear, currentMonth + 1, 0); //来月0日 = 今月末
  const currentMonth_lastDate_format = new Intl.DateTimeFormat('js-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(currentMonth_lastDate).replace(/\//g, '-');
  //console.log(currentMonth_lastDate_format); // 2024-03-22

  //先月1日 = today（今月・先月を表示したいため）
  const previouwMonth_firstDate = new Date(currentYear, currentMonth - 1, 1); //先月1日
  //console.log(previouwMonth_firstDate);

  //投稿のある最初の月の1日 = date.min
  const first_has_post_date = new Date(2021, 11, 1); //2021/12/1 月は0-11
  const first_has_post_date_format = new Intl.DateTimeFormat('js-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(first_has_post_date).replace(/\//g, '-');

  const date_min = first_has_post_date_format;
  const date_max = currentMonth_lastDate_format;
  const date_today = previouwMonth_firstDate; //today:はフォーマットしない

  const options = {
    type: 'multiple',
    months: 2,
    jumpMonths: 2,
    date: {
      min: date_min,
      max: date_max,
      today: date_today,
    },
    settings: {
      lang: 'ja',
      iso8601: false,
      visibility: {
        today: false,
        theme: 'light',
        daysOutside: false,
        disabled: true,
      },
      range: {
        min: date_min,
        max: date_max,
      },
      selection: {
        day: 'single',
        month: 'only-arrows',
        year: false,
        time: false,
      }
    },
    actions: {
      clickArrow(e, self) {
        let selectedY = self.selectedYear;
        let selectedM = self.selectedMonth + 1;
        if (wrapper) {
          wrapper.classList.remove('ajax-end');
        }
        loadNew(selectedY, selectedM);
      },
      clickDay(e, self) {
        const linked_url = self.popups[self.selectedDates[0]]['href'];
        location.href = linked_url;
      },
    },

  };

  window.addEventListener('load', function () {
    calendar = new VanillaCalendar('#calendar', options);
    calendar.init();
    loadNew(currentYear, currentMonth);
  });

}
